import MobileViewWrapper from "pages/MobileViewWrapper/MobileViewWrapper";
import { Redirect, Route } from "react-router-dom";
import { routeTable } from "routes/routeData";

export function MobileRouterOutlet() {
  return (
    <>
      {routeTable.map((route, idx) => {
        const { mobileTitle, path, component: Component } = route;

        return (
          <Route exact key={`mobile-route-${idx}`} path={path}>
            <MobileViewWrapper title={mobileTitle}>
              <Component />
            </MobileViewWrapper>
          </Route>
        );
      })}
      <Route exact path="/">
        <Redirect to="/active-requests"></Redirect>
      </Route>
    </>
  );
}
